import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import { countryCodeToEmoji } from "./countries";
export const playerDisplayName = (player) => {
    if (!player) {
        return "";
    }
    const model = player.user || player.externalUser;
    if (model === null) {
        throw new Error("Cannot retrieve Player User!");
    }
    return `${model.firstName} ${model.lastName}`;
};
export const PlayerDisplayNameLink = ({ player, reverse = false, }) => {
    const displayName = playerDisplayName(player);
    if (!player) {
        return _jsx(Fragment, { children: displayName });
    }
    return PlayerNameLink({
        id: player.id,
        name: displayName,
        nationality: player.nationality,
        reverse,
    });
};
export const PlayerNameLink = ({ id, name, nationality, reverse = false, }) => {
    const flag = nationality ? countryCodeToEmoji(nationality) : "";
    const label = name ?? "";
    return (_jsx(Link, { style: { textDecoration: "none" }, to: `/players/${id}/`, children: reverse
            ? `${label}${flag ? ` ${flag}` : ""}`
            : `${flag ? `${flag} ` : ""}${label}` }, id));
};
